import React from 'react';

// Es necesario que el elemento padre que se encarga de manejar los eventos
// onMouseEnter y onMouseLeave, tenga un position realive
const CustomTooltip = ({ children, anchor, elementId, stylesProp }) => {
  return (
    <div
      style={
        anchor == elementId
          ? {
              position: 'absolute',
              zIndex: 1300,
              background: 'white',
              width: 'fit-content',
              maxWidth: '360px',
              borderRadius: '8px',
              border: '1px solid #E5E5E5',
              padding: '16px',
              boxSizing: 'border-box',
              top: '100%',
              ...stylesProp,
            }
          : { display: 'none' }
      }
    >
      {children}
    </div>
  );
};

export default CustomTooltip;
